import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Public pages
import ChatPage from './pages/ChatPage';
import LandingPage from './pages/LandingPage';

// Admin pages
import AdminDashboard from './pages/AdminDashboard';
import ChatLogsPage from './pages/ChatLogsPage';
import EmailStatsPage from './pages/EmailStatsPage';
import InstructAIPage from './pages/InstructAIPage';
import WidgetAnalyticsPage from './pages/WidgetAnalyticsPage';
import WidgetChatsPage from './pages/WidgetChatsPage';
import WidgetManagerPage from './pages/WidgetManagerPage';
import UrlTrainerPage from './pages/UrlTrainerPage';
import AdminBrandRouterPage from './pages/AdminBrandRouterPage';



// Admin bootstrap + admin registration
import AdminBootstrapPage from './pages/AdminBootstrapPage';
import AdminRegisterPage from './pages/AdminRegisterPage';

// Admin-only login
import LoginPage from './pages/LoginPage';

// Gates
import AdminGate from './routes/AdminGate';
import AdminRoute from './routes/AdminRoute';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/landing.css';

export default function App() {
  const token = useSelector((s) => s.auth.token);
  const isAdmin = useSelector((s) => s.auth.is_admin || s.auth.is_staff || s.auth.is_superuser);

  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/chat" element={<ChatPage />} />

        {/* One-time superadmin bootstrap (server enforces X-Setup-Token) */}
        <Route path="/admin/bootstrap" element={<AdminBootstrapPage />} />

        {/* Admin-only LOGIN (behind PIN) */}
        <Route
          path="/admin/login"
          element={
            <AdminGate>
              {token && isAdmin ? <Navigate to="/admin" replace /> : <LoginPage />}
            </AdminGate>
          }
        />

        {/* Admin-only APP routes (PIN + token + role) */}
        <Route
          path="/admin"
          element={
            <AdminGate>
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/admin/register"
          element={
            <AdminGate>
              <AdminRoute>
                <AdminRegisterPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/chatlogs"
          element={
            <AdminGate>
              <AdminRoute>
                <ChatLogsPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/stats"
          element={
            <AdminGate>
              <AdminRoute>
                <EmailStatsPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/instruct"
          element={
            <AdminGate>
              <AdminRoute>
                <InstructAIPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/branding"
          element={
            <AdminGate>
              <AdminRoute>
                <AdminBrandRouterPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/widgets/:token/analytics"
          element={
            <AdminGate>
              <AdminRoute>
                <WidgetAnalyticsPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/widgets/:token/chats"
          element={
            <AdminGate>
              <AdminRoute>
                <WidgetChatsPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/widgets"
          element={
            <AdminGate>
              <AdminRoute>
                <WidgetManagerPage />
              </AdminRoute>
            </AdminGate>
          }
        />
        <Route
          path="/train-url"
          element={
            <AdminGate>
              <AdminRoute>
                <UrlTrainerPage />
              </AdminRoute>
            </AdminGate>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
